import { useEffect, useRef } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogViewMarketRanking = (marketTypeName: string | undefined) => {
  const hasLoggedRef = useRef(false);

  useEffect(() => {
    if (hasLoggedRef.current) return;
    if (marketTypeName == null) return;

    bridge.logAnalyticsEvent({
      name: 'VIEW_MARKET_RANKING',
      analytics: {
        SCREEN: 'MARKET_RANKING',
        TYPE: marketTypeName,
      },
    });
    hasLoggedRef.current = true;
  }, [marketTypeName]);
};
